﻿import 'normalize.css/normalize.css';
import 'react-toastify/dist/ReactToastify.min.css';
import 'react-phone-number-input/style.css';
import 'react-image-gallery/styles/css/image-gallery.css';

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import DateFnsUtils from '@date-io/date-fns';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { createTheme, ThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import ReactPixel from 'react-facebook-pixel';
import { maintenanceMode } from 'config/config';


import { facebookPixelId } from 'config/config';
import BranchService from 'services/branch.service';
import UserProvider from 'components/UserProvider';
import { useBranch } from 'components/BranchProvider';
import Navbar from 'components/Navbar';
import MobileDrawer from 'components/MobileDrawer';
import NotificationListWidget from 'containers/NotificationListWidget';
import InboxWidget from 'containers/InboxWidget';
import Loader from 'components/Loader';
import styleVars_17 from "styles/colors.module.scss";
const { white01,
  lightTurquoise,
  orange01,
  turquoise01,
  bluePrimaryDark,
} = styleVars_17;
import 'styles/main.scss';

import * as actions from './App.ducks';
import { MaintenanceDueModal } from './components';

const MAINTENANCE_DUE_MODAL_ID = 'Conversation/MAINTENANCE_DUE_MODAL_ID';

const theme = createTheme({
  palette: {
    primary: {
      light: lightTurquoise,
      main: turquoise01,
      dark: bluePrimaryDark,
      contrastText: white01,
    },
    secondary: {
      light: orange01,
      main: orange01,
      dark: orange01,
      contrastText: white01,
    },
  },
  components: {
    MuiMenuItem: {
      styleOverrides: {
        root: {
          '&.Mui-selected': {
            backgroundColor: turquoise01,
          },
          '&.Mui-selected:hover': {
            backgroundColor: turquoise01,
          },
        },
      },
    },
  },
});

// TODO: Move this to App.sss file
const styles = {
  noScroll: {
    overflow: 'hidden',
    position: 'fixed',
    top: 64,
    right: 0,
    left: 0,
    bottom: 0,
  },
  drawerOpen: {
    marginTop: 64,
  },
};

function App({
  children,
  isLoggedIn,
  appIsInitialized,
  user,
  logout,
  inboxListOpen,
  notificationListOpen,
  initialize,
}) {
  const [mobileDrawerOpen, setMobileDrawerOpen] = React.useState(false);
  const [branch, setBranch] = useBranch();

  React.useEffect(() => {
    const bootstrapApp = (id) => {
      const branchId = Number(id);
      return BranchService.get(branchId).then(setBranch);
    };
    if (facebookPixelId) {
      ReactPixel.init(facebookPixelId);
    }
    initialize({ bootstrapApp });
  }, [initialize, setBranch]);

  function toggleMobileDrawer(open) {
    let newValue = open;
    if (typeof open !== 'boolean') {
      newValue = !mobileDrawerOpen;
    }
    setMobileDrawerOpen(newValue);
  }

  if (maintenanceMode) {
    return <h1>App in maintenance, please come back later...</h1>;
  }

  if (!appIsInitialized) {
    return (
      <Loader loading type="fixed" size="large">
        Clear Connection by Natural Acne Clinic
      </Loader>
    );
  }

  const drawerOpen = notificationListOpen || inboxListOpen;
  let containerStyles = {};

  if (mobileDrawerOpen) {
    containerStyles = {
      ...containerStyles,
      ...styles.noScroll,
    };
  }

  if (drawerOpen) {
    containerStyles = {
      ...containerStyles,
      ...styles.drawerOpen,
    };
  }

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <UserProvider user={user}>
        <StyledEngineProvider injectFirst>
          <ThemeProvider theme={theme}>
            <>
              {isLoggedIn && (
                <>
                  <Navbar
                    logout={logout}
                    mobileDrawerOpen={mobileDrawerOpen}
                    toggleMobileDrawer={toggleMobileDrawer} // eslint-disable-line react/jsx-no-bind
                  />
                  {branch.client_coach_assignment_enabled && (
                    <NotificationListWidget />
                  )}
                  {branch.messaging_enabled && <InboxWidget />}
                  <MaintenanceDueModal modalId={MAINTENANCE_DUE_MODAL_ID} />
                </>
              )}
              <MobileDrawer
                toggle={toggleMobileDrawer} // eslint-disable-line react/jsx-no-bind
                logout={logout}
                open={mobileDrawerOpen}
              />
              <ToastContainer autoClose={3000} pauseOnFocusLoss={false} />
              <div style={containerStyles}>{children}</div>
            </>
          </ThemeProvider>
        </StyledEngineProvider>
      </UserProvider>
    </LocalizationProvider>
  );
}

App.propTypes = {
  children: PropTypes.node.isRequired,
  isLoggedIn: PropTypes.bool.isRequired,
  appIsInitialized: PropTypes.bool.isRequired,
  user: PropTypes.object.isRequired,
  inboxListOpen: PropTypes.bool.isRequired,
  notificationListOpen: PropTypes.bool.isRequired,
  initialize: PropTypes.func.isRequired,
  logout: PropTypes.func.isRequired,
};

const mapStateToProps = ({ app, user, inbox, notificationList }) => ({
  ...app,
  user,
  inboxListOpen: inbox.open,
  notificationListOpen: notificationList.open,
});

export default connect(mapStateToProps, actions)(App);
